export enum ProjectSettingsKey {
  HVAC_RESULTS_ACCURACY_WARNING = 'hvac-results-accuracy-warning',
  ANNUAL_SAVING = 'annualSaving',
}
